import {
  Component,
  Inject,
  OnInit,
  Optional,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { DIALOG_DATA } from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { UserProfileService } from '../../../profile/user-profile/user-profile.service';

@Component({
  selector: 'gtapp-multiple-accounts',
  standalone: false,
  templateUrl: './multiple-accounts.component.html',
  styleUrl: './multiple-accounts.component.scss',
})
export class MultipleAccountsComponent implements OnInit {
  @ViewChild('addAccountTemplate') addAccountTemplate: any;
  userLinkedAccounts: any = [];

  displayMessage: string = '';

  alreadyExistingEmails: any = [this.appService.getUserData()?.profile?.email];

  addNewAccountRef: any;

  userData: any;

  showCloseIcon: boolean = true;
  isLogginOut: boolean = false;

  constructor(
    @Optional() protected dialogRef: DialogRef,
    private appService: AppService,
    private spinnerService: LoadingSpinnerService,
    private profileService: UserProfileService,
    private dialogService: ModalDialogueService,
    private viewContainerRef: ViewContainerRef,
    @Inject(DIALOG_DATA) public dialogData: any,
  ) {}

  ngOnInit(): void {
    this.getAssociatedAccounts();
    this.userData = this.appService.getUserData();
    this.isLogginOut = this.dialogData?.logout || false;
    if (this.isLogginOut) this.showCloseIcon = false;
  }

  getAssociatedAccounts() {
    this.spinnerService.show();
    let userLinkedAccountTokens: any = JSON.parse(
      localStorage.getItem(btoa('userLinkedAccountTokens')) || '[]',
    );
    userLinkedAccountTokens = [
      ...new Set([
        ...userLinkedAccountTokens,
        this.appService.getUserData()?.access,
      ]),
    ];
    localStorage.setItem(
      btoa('userLinkedAccountTokens'),
      JSON.stringify(userLinkedAccountTokens),
    );

    this.profileService
      .associatedCompanies(
        { access_tokens: userLinkedAccountTokens },
        { get_companies: 1 },
      )
      .subscribe((res: any) => {
        if (res['status'] === 'success') {
          this.spinnerService.hide();

          userLinkedAccountTokens = res?.data?.map(
            (account: any) => account?.access_token_passed,
          );
          localStorage.setItem(
            btoa('userLinkedAccountTokens'),
            JSON.stringify(userLinkedAccountTokens),
          );

          if ((res?.data || [])?.length === 1) this.openAddAccountTemplate();
          if (this.isLogginOut) {
            // remove the exiting data and silently switch to another one

            let remainingAccounts: any = [];
            let currentAccount: any = {};

            res?.data?.forEach((account: any) => {
              if (
                this.userData?.subscriber?.subscriber_user_id !==
                account?.sub_user_id
              ) {
                remainingAccounts.push(account);
              } else {
                currentAccount = account;
              }
            });

            userLinkedAccountTokens = userLinkedAccountTokens?.filter(
              (token: any) => token != currentAccount?.access_token_passed,
            );

            localStorage.setItem(
              btoa('userLinkedAccountTokens'),
              JSON.stringify(userLinkedAccountTokens),
            );
            this.userLinkedAccounts = remainingAccounts || [];
            if (remainingAccounts?.length) {
              this.appService.onAccountChange(remainingAccounts[0]);
            } else {
              window.location.reload();
            }
          } else {
            this.userLinkedAccounts = res?.data || [];
          }
        } else {
          this.onCloseDialogue();
        }
      });
  }
  onCloseDialogue(val = 'close') {
    this.dialogRef.close(val);
  }
  async selectSubscriber(subscriber: any) {
    this.spinnerService.show('Switching Account');
    this.onCloseDialogue(subscriber);
  }

  openAddAccountTemplate() {
    this.addNewAccountRef = this.dialogService.open(
      this.addAccountTemplate,
      {},
      this.viewContainerRef,
    );
    this.addNewAccountRef.afterClosed().subscribe((res: any) => {
      if (!res) this.onCloseDialogue();
    });
  }

  emitLoggedInData(eventData: any) {
    switch (eventData?.source) {
      case 'multipleSubscribers':
        if (eventData?.response?.status === 'success') {
          const subscriberTokenList = eventData?.response?.data
            ?.filter((item: any) => item?.id)
            ?.map((item: any) => item?.login_access_data?.access);

          let userLinkedAccountTokens: any =
            JSON.parse(
              localStorage.getItem(btoa('userLinkedAccountTokens')) || '[]',
            ) || [];
          userLinkedAccountTokens = [
            ...userLinkedAccountTokens,
            ...subscriberTokenList,
          ];

          userLinkedAccountTokens = [...new Set(userLinkedAccountTokens)];

          localStorage.setItem(
            btoa('userLinkedAccountTokens'),
            JSON.stringify(userLinkedAccountTokens),
          );
          this.getAssociatedAccounts();
          this.addNewAccountRef?.close(true);
          this.showCloseIcon = false;
          sessionStorage.setItem(btoa('newAccountLinked'), 'true');
        }
        break;
      case 'loginSuccessAction':
        if (eventData?.response?.status === 'success') {
          // append to localStorage the access token which then should be used to call the api,
          // because the user may have multiple subscribers associated with it which will be hard to track if storing the details

          let userLinkedAccountTokens: any =
            JSON.parse(
              localStorage.getItem(btoa('userLinkedAccountTokens')) || '[]',
            ) || [];
          userLinkedAccountTokens.push(eventData?.response?.access);
          userLinkedAccountTokens = [...new Set(userLinkedAccountTokens)];
          localStorage.setItem(
            btoa('userLinkedAccountTokens'),
            JSON.stringify(userLinkedAccountTokens),
          );
          this.getAssociatedAccounts();
          this.addNewAccountRef?.close(true);
          this.showCloseIcon = false;
          sessionStorage.setItem(btoa('newAccountLinked'), 'true');
        }

        break;
      case 'displayMessage':
        this.displayMessage = eventData?.response?.message;
        break;
    }
  }
}
